// ----------------------------------------------------------------------------
// Template: Index
// ----------------------------------------------------------------------------
// Home Page Template
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'sections/intro-block/intro-block';
import 'sections/collection-list/collection-list';
import 'sections/page-hero/page-hero';
import 'sections/info-panel/info-panel';
import 'sections/compare-block/compare-block';
import 'sections/content-panel/content-panel';
import 'sections/faqs/faqs';
import 'sections/testimonial/testimonial';
import 'sections/featured-collection/featured-collection';
import 'sections/blog-posts/blog-posts';
import 'sections/newsletter/newsletter';
import 'sections/statements-block/statements-block';
import 'sections/bundle-cards/bundle-cards';
import 'sections/detailed-product/detailed-product';
import 'sections/collections-carousel/collections-carousel';